export const styleSheet = theme => ({
    container: {
        // You probably can remove this
        backgroundColor: theme.colors.white02
    },
    menu: {
        maxHeight: 600
    }
});
